import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import Programs from '../../components/programs/index';
// import Banner from '../../common/Banner/Banner';
import { fetchProgramsDataIfNeeded } from '../../components/programs/actions/ProgramsAction';

const headerTags =
{
    title: 'Programação - Saiba as informações e horários', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Na Antena 1 tem programas matinais, vesperais e noturnos para alegrar todo o seu dia. Conheça toda a grade de programação da rádio número 1 em música.',
        keywords: '10+, 10 mais, 10+ europa, 10 mais europa, 100+, 100 mais, daylight, clássicos, big hour, big hour live, montagem, montagem exclusiva, 70 80 90, antena 1 news, antena 1 notícia, a mais pedida, a mais pedida do whatsapp, aeroportos, manchetes do dia, mercado financeiro, grade, grade de programação, programas matinais, programas da tarde, programas de noite, música 24 horas',
        'og:title': 'Programação - Saiba as informações e horários',
        'og:description': 'Na Antena 1 tem programas matinais, vesperais e noturnos para alegrar todo o seu dia. Conheça toda a grade de programação da rádio número 1 em música.',
    },
};

// Banners

// const programsBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-programs-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

class Programacao extends Component {
    static fetchData(store) {
        return store.dispatch(fetchProgramsDataIfNeeded());
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-m-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <Programs />
                {/* <Banner key={programsBannerConfig.adUnit} config={programsBannerConfig} /> */}
            </div>
        );
    }
}

export default Programacao;
